<template>
  <div :class="isActive ? 'fullScreenContainer active' : 'fullScreenContainer'">
    <div class="popupContainer">
      <div class="topTextContainer">{{ popupText }}</div>
      <div class="bottomButtonsContainer">
        <div class="agreeButton" @click="agreeButtonClicked()">I AGREE</div>
        <div class="cancelButton" @click="cancelButtonClicked()">CANCEL</div>
      </div>
    </div>
  </div>
</template>
<script>
import "../scss/external-link-popup.css";

export default {
  props: {},
  methods: {
    agreeButtonClicked() {
      window.open(this.popupLink, "_blank").focus();
      this.isActive = false;
    },
    cancelButtonClicked() {
      this.$root.$emit('playVideo') 
      this.isActive = false;
    },
    resetPopupText() {
      this.popupText =
        "You are leaving BiosimilarsMedicalAcademy.de and entering a website that we dont control.\n\nBiosimilars Medical Academy has provided this link for your convenience, but is not responsible for the content, links, privacy policy, or security of this website.";
    },
    showPopup(e) {
      this.$root.$emit('pauseVideo') 
      if (e.detail.alertText) {
        this.popupText = e.detail.alertText;
      }
      else{
          this.resetPopupText()
      }
      this.popupLink = e.detail.routeLink;
      this.isActive = true;
    }
  },
  mounted() {
    this.resetPopupText();
    window.addEventListener("openLink", this.showPopup);
  },
  data() {
    return {
      popupText: "",
      popupLink: "",
      isActive: false,
    };
  },
};
</script>
